export const P_SPRINGT_CONTENT = {
  title: 'P_Springt',
  subtitle: 'P_Springt',
  source: 'Version 1.0',
  referenceDocument: {
    label: 'Original-PDF herunterladen',
    href: '/einsatz/p-springt/handkarte-p-springt.pdf',
    filename: 'Handkarte P-Springt.pdf',
  },
  sections: [
    {
      id: 'p-springt-aufgaben',
      title: 'Aufgabenverteilung',
      blocks: [
        {
          paragraphs: [
            { text: 'CAVE: Polizei Lage\nEigenschutz / Bewaffnung?', strong: true, color: 'error.main' },
          ],
        },
        {
          groups: [
            {
              title: 'GF:',
              items: ['Anfahrt / Einsatzstelle mit EL absprechen', 'Aufstellung außerhalb Sichtbereich'],
            },
            {
              title: 'MA:',
              items: ['Sondersignal notwendig?'],
            },
            {
              title: '2. Retter:',
              items: ['Wortführer bei Erstkontakt', 'mit Sicherung vorgehen', 'Faps + Notizmöglichkeit + Pat. Rucksack'],
            },
            {
              title: '1. Retter:',
              items: [
                'Interventionsbereit',
                'mit Sicherung vorgehen',
                'Faps + Varioschlinge (min.150cm)',
                'Dyn. Seil / Vorstiegsset',
              ],
            },
            {
              title: '1. + 2. Sicherer:',
              items: ['Festpunkt / Türanker', 'Standardrucksack', 'Seilsack 100m'],
            },
          ],
        },
      ],
    },
    {
      id: 'p-springt-einsatzleiter',
      title: 'Info für Einsatzleiter',
      groups: [
        {
          title: 'Erstkontakt:',
          items: [
            'Polizeilage\n• Diese ist der FW weisungsbefugt!',
            'Einsatzleiter-FW <-> Polizei',
            'Erstkontakt erst nach Absprache',
            'immer zwei Höhenretter',
            'mit dauerhafter Funkverbindung',
          ],
        },
        { title: 'Support:', items: ['Polizei / SEK etc.'] },
        { title: 'Vorschläge:', items: ['Beratung / Absprache'] },
        { title: 'Blocken:', items: ['Verschließen o. Sichern von Wegen und Fenstern'] },
        { title: 'Handlungsbereitschaft:', items: ['Erkundung / Vorbereitung für die Sofortrettung'] },
      ],
    },
    {
      id: 'p-springt-einsatzstelle',
      title: 'Einsatzstelle',
      blocks: [
        {
          groups: [
            {
              title: 'Einsatzstelle',
              items: [
                'Einsatzstellenfunk verfolgen!',
                'Abstimmung EL-FW <-> Polizei',
                'Dauerhafte Kommunikation',
                'Kanaltrennung erfragen!\n• Schalten separater Arbeitskanal nach Freigabe des Einsatzleiters (zB 312)',
                'Kontaktaufnahme Polizei!',
                'FW nur nach Rücksprache -> wenn dann nur im Team',
                'Wortführer + 1. Retter\n• Kontrolle der Situation\n• Einschätzung von Bewaffnung\n• Erhöhte Sicherheit in der Eskalation',
              ],
            },
          ],
        },
        {
          paragraphs: [
            { text: 'CAVE:\nKeine Angehörigen/Freunde etc.\nSind fernzuhalten!', strong: true, color: 'error.main' },
          ],
        },
      ],
    },
    {
      id: 'p-springt-erstkontakt',
      title: 'Erstkontakt',
      blocks: [
        {
          groups: [
            {
              title: 'Gut ☺',
              items: [
                'Vorstellen mit Namen',
                'menschlich / verständnisvoll',
                'ruhig / geduldig / klare Aussagen',
                'Suizid offen ansprechen',
                'aktiv Zuhören und ernstnehmen',
                'Blickkontakt / offene Körpersprache',
                'Pausen zulassen',
                'eigene Eindrücke verbalisieren\n(„Ich sehe, dass du zitterst, ist dir kalt?“)',
                'Stabilisieren: Pat. Verbal erreichen',
                'Aufklärung: Infos von Pat. Einholen',
                'Beweggründe als Gesprächsgrundlage',
              ],
            },
            {
              title: 'Schlecht ☹',
              items: [
                'Keine Bagatellisierung / Abwertung',
                'Keine falschen Zusagen',
                'Keine schnellen Lösungen -> Geduld',
                'Keine bedrängende Körpersprache',
              ],
            },
          ],
        },
      ],
    },
  ],
};
